export default __webpack_public_path__ + "static/media/ion_open-outline.db97bfff.svg";